import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { CircularProgress, Container, Grid, Typography } from "@mui/material";
import SingleProject from '../SingleProject/SingleProject';

const Projects = () => {
    const [projects, setPorject] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=>{
        setIsLoading(true);
        fetch('https://immense-tor-98542.herokuapp.com/projects')
        .then(res => res.json())
        .then(data => setPorject(data))
        setIsLoading(false);
    },[]);

    return (
    <Box sx={{ mt: 16, mb: 8 }}>
        <Typography variant="h4">
            My Projects
        </Typography>
        <Container sx={{ mt: 5 }}>

        {!isLoading && <Grid container spacing={2}>
            {
                projects.map(project => <SingleProject key={project.id} project={project} isLoading={isLoading} />)
            }

        </Grid>}
        {isLoading && <CircularProgress />}
        </Container>
      </Box>
    );
};

export default Projects;